import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var AutoMateLogoIcon = function AutoMateLogoIcon(props) {
  var _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 400 400' : _props$viewBox,
      _props$width = props.width,
      width = _props$width === void 0 ? '24px' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '24px' : _props$height;
  var classes = useStyles(props);
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: viewBox,
      width: width,
      height: height
    },
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M341.6,58.4c78.3,78.3,78.3,205,0,282.9c-78.3,78.3-205,78.3-282.9,0c-78.3-77.9-78.3-204.6-0.4-282.9     C136.6-19.5,263.4-19.5,341.6,58.4"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls2,
      d: "M328.5,195l-12.6-4.3c-23.7-8.2-33.7-36.3-20.4-57.5l6.8-10.9c-7.7-10.1-16.8-18.9-27-26.3l-10.6,6.7   c-21.2,13.5-49.4,3.7-57.7-19.9l-3.9-11.2c-9.1-0.2-18.4,0.5-27.7,2.3c-3.4,0.7-6.8,1.6-10.1,2.5l-1.2,11.4   c-2.7,24.9-27.9,40.9-51.6,32.7l-10.3-3.6c-8.3,9.8-15.2,20.8-20.3,32.7l7.7,7.6c17.8,17.6,14.6,47.3-6.6,60.7l-9.2,5.8   c0.1,0.4,0.1,0.7,0.2,1.1c2.5,12.6,6.8,24.4,12.4,35.2l11.1-1.3c24.9-2.9,46.1,18.1,43.3,43l-1.3,11.7c11.1,6,23.2,10.3,35.8,12.7   l6.4-10.4c13.2-21.3,42.9-24.8,60.6-7.1l9.1,9.1c11.7-5.1,22.4-11.8,31.8-19.9l-4.4-12.4c-8.4-23.6,7.4-48.9,32.3-51.8l13.3-1.5   C327.6,220.2,329,207.8,328.5,195z M210.5,252.6c-29,5.7-57.2-13.2-62.9-42.3c-5.7-29,13.2-57.2,42.3-62.9s57.2,13.2,62.9,42.3   C258.4,218.7,239.5,246.9,210.5,252.6z"
    }))
  );
};
var useStyles = makeStyles(function (theme) {
  return {
    cls1: function cls1(props) {
      return {
        fill: props.color ? props.color : theme.palette.product.automate
      };
    },
    cls2: {
      fill: theme.palette.common.white,
      fillRule: 'evenodd'
    }
  };
});